import { Grid, TextField, Typography } from "@mui/material";
import { FormTitleGrid } from "../../../styles";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";

export const ExtraInfo = () => {
  const { t } = useTranslation("order");
  const { control, watch } = useFormContext();
  const { isReadOnly } = watch();

  return (
    <FormSection title={t("common:additionalInfo")}>
      <FormTitleGrid container item xs={4}>
        <Typography variant="secondary">{t("extraInfo")}</Typography>
      </FormTitleGrid>
      <Grid item xs={8} display="flex">
        <Controller
          name="descriptionToEezyAndCustomer"
          control={control}
          render={({ field }) => (
            <TextField
              fullWidth
              value={field.value}
              disabled={isReadOnly}
              onChange={field.onChange}
              name={field.name}
              size="small"
              helperText={t("visibleToCustomerAndEezy")}
            />
          )}
        />
      </Grid>
    </FormSection>
  );
};
